export default __webpack_public_path__ + "static/media/johan.243dbc7b.jpg";